module.exports = __webpack_public_path__ + "img/botao-circular-de-download.c0ecd645.png";